import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    
    DialogTitle, FormControl, IconButton
} from "@mui/material";
import { Tooltip } from "antd";
import { makeStyles } from "@mui/styles";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import SearchIcon from "@mui/icons-material/Search";
import Layout from "../../components/Wrappers/Layout";
import failed from "../../assets/img/failed.png";
import getSymbolFromCurrency from "currency-symbol-map";
import {
    Alert, Row,
    Col,
    Card
} from "reactstrap";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns"
// import { AiOutlineSearch } from "react-icons/ai";
// import { AiOutlineUserAdd } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
// import { FormControl } from "@mui/material";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import Box from '@mui/material/Box';
import Collapse from '@mui/material/Collapse';
// import IconButton from "@mui/material/IconButton";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
import NotificationPopups from "../../NotificationPopup/NotificationPopups";
import Autocomplete from "@mui/lab/Autocomplete";
import { createFilterOptions } from "@mui/material";
// import Autocomplete, {
//     createFilterOptions
// } from "@mui/material/lab/Autocomplete";
//resetGetWayTransactionList, getWayTransactionList
import {
    resetGetWayTransactionList,
    getWayTransactionList
} from "../../redux/actions/getWayTransactionListAction";
import {
    resetViewTransactionDetails,
    getViewTransactionDetails
} from "../../redux/actions/viewTransactionDetailsAction";
import { NavLink, Link, useHistory, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import "../../components/LoadingSpinner/spinner.css";
import BackButton from "../../components/BackButton/BackButton";
import Util from "../../validation";
import SOLogout from "../../components/Logout/SOLogout";
import { getUserNameContactSuggestionList } from "../../redux/actions/partnerGetUserNameContactSuggestionAction"
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
// import { getCode } from "../../utils/countries";
import { getCodes } from "../../utils/countriesDropdown"
import { getWalletOwnerIdAndNameList } from "../../redux/actions/getWalletOwnerIdAndNameListAction";
import { getInquirysAdmin, resetGetInquiryAdmin } from "../../redux/actions/adminGetInquiryAction"
// import AssignmentIcon from '@mui/icons-material/Assignment';
import FindInPageIcon from '@mui/icons-material/FindInPage';
import EditIcon from "@mui/icons-material/Edit";
import success from "../../assets/img/success.png";
import { partnerBulkUpdateStatus, resetBulkUpdateStatusPartner } from "../../redux/actions/bulkUpdateStatusPartnerAction"
import val from "../../getThemeDetails";
import { resetUpdateGatewayTransactionAdmin, AdminUpdateGatewayTransactions } from "../../redux/actions/adminUpdateGatewayTransactionAction";
const useStyles = makeStyles({
    table: {
        minWidth: 650
    }
});

const AdminTransaction = () => {
    const [isLoading, setIsLoading] = useState(false);
    const dispatch = useDispatch();
    // const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;

    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    const adminInquiryDetailsRes = useSelector(
        ({ adminGetInquiryLists }) => adminGetInquiryLists
    );
    const adminUpdateGatewayTransactionRes = useSelector(
        ({ adminUpdateGatewayTransactionStatus }) => adminUpdateGatewayTransactionStatus
    );

    var authToken = regenerateTokenRes.data.AuthToken;

    var date = new Date();
    const [selectedDate, setSelectedDate] = useState(
        new Date(date.getFullYear(), date.getMonth(), 1)
    );
    const navigate = useHistory();
    const [getTransactionTypeListResArray, setGetTransactionTypeListResArray] =
        useState("");
    const [selectedToDate, setSelectedToDate] = useState(new Date());
    const [customerId, setCustomerId] = useState("");
    const [transactionId, setTransactionId] = useState("");
    const [transactionType, setTransactionType] = useState("");
    const [transStatus, setTransStatus] = useState("");
    console.log(transStatus, "transStatus")
    const [toCustContact, setToCustContact] = useState("");
    const [toCustName, setToCustName] = useState("")
    const [currency, setCurrency] = useState("");
    const [isFee, setIsFee] = useState("");
    // const [rowsPerPage, setRowsPerPage] = useState(5);
    // const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [pageNo, setPageNo] = useState(0)
    const [customerOrMobName, setCustomerOrMobName] = useState("");

    const [isMaskedEmail, setIsMaskedEmail] = useState(true);
    const [partnerId, setpartnerId] = useState('');

    const [getWalletOwnerIdStatus, setGetWalletOwnerIdStatus] = useState(false);
    const [getWalletOwnerIdResArray, setGetWalletOwnerIdResArray] = useState([]);

    const [openUpdateModal, setOpenUpdateModal] = React.useState(false);
    const [getRemark, setGetRemark] = useState("");

    const [orgnDesc, setorgnDesc] = useState("");
    const [openPopup, setOpenPopUp] = useState(false)
    const [handleOpenUpdateInqRespModal, setHandleOpenUpdateInqRespModal] = useState(false)
    const [viewUpdateResArray, setViewUpdateResArray] =
        useState([]);

    const [notificationRefundOpen, setNotificationRefundOpen] =
        React.useState(false);

    // const maskEmail = (isMaskedEmail = '') => 
    // 	const [name, domain] = email.split('@');
    // 	const { length: len } = name;
    // 	const maskedName = name[0] + '...' + name[len - 1];
    // 	const maskedEmail = maskedName + '@' + domain;
    // 	return maskedEmail;
    //  };
    const [nextPageUntick, setNextPageUntick] = useState(false);
    const BulkUpdateStatusPartnerRes = useSelector(
        ({ partnerBulkUpdateStatusLists }) => partnerBulkUpdateStatusLists
    );
    const [bulkStatusOpen, setBulkStatusOpen] =
        React.useState(false);



    const [viewTransactionDetailsResArray, setViewTransactionDetailResArray] =
        useState([]);
    const [viewInquiryDetailsResArray, setViewInquiryDetailsResArray] =
        useState([]);

    const viewTransactionDetailsRes = useSelector(
        ({ viewTransactionDetails }) => viewTransactionDetails
    );
    const getWalletOwnerIdRes = useSelector(
        ({ getWalletOwnerIdAndNameList }) => getWalletOwnerIdAndNameList
    );

    const [open, setOpen] = useState(null);
    const [inquiryOpenModal, setInquiryOpenModal] = useState(false);
    const [partnerIdForView, setPartnerIdForView] = useState("")

    const [updateStatus, setUpdateStatus] = useState("");

    const [autocompleteDataName, setautocompleteDataName] = useState("");

    const [dataAutocompleteName, setdataAutocompleteName] = useState([]);
    const [boolSetName, setboolSetName] = useState(false);
    const getUsernameSuggestionRes = useSelector(
        ({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
    )



    const classes = useStyles();

    const [getWayTransactionListStatus, setgetWayTransactionListStatus] =
        useState(false);
    // const filterOptions = createFilterOptions({
    // 	matchFrom: "any",
    // 	limit: 500
    // });
    const handleChange = ({ target: { name, value } }) => {
        if (name === "customerId") {
            setCustomerId(value);
            // Util.verifyMobile(value) ? setCustomerId(value) : setCustomerId(customerId)
        }

        if (name === "transactionId") {
            // setTransactionId(value);
            Util.verifyMobile(value)
                ? setTransactionId(value)
                : setTransactionId(transactionId);
        }

        if (name === "transactionType") {
            setTransactionType(value);
        }
        if (name === "transStatus") {
            setTransStatus(value);
        }
        if (name === "toCustContact") {
            setToCustContact(value);
        }
        if (name === "toCustName") {
            // Util.verifyAlphabet(value)
            //     ? setToCustName(value)
            //     : setToCustName(toCustName);
            setToCustName(value);
        }
        if (name === "customerOrMobName") {
            console.log("custttttNammmmee", customerOrMobName)
            setCustomerOrMobName(value)
        }
        if (name === "currency") {
            setCurrency(value);
        }

        if (name === "isFee") {
            setIsFee(value);
        }
        if (name === 'partnerId') {
            setpartnerId(value);
            // setpartnerId(value == "Select Owner ID" ? "" : value);
            getUserContactReq(value)
            getUserNameReq(value)
            // setautocompleteDataName("");



        }
        if (name === "getRemark") {
            console.log("VALUESSSS", value)
            setGetRemark(value);
        }
        if (name === "orgnDesc") {
            console.log("VALUESSSS", value)
            setorgnDesc(value);
        }

        if (name === "updateStatus") {
            setUpdateStatus(value);

        }


    };



    const handleNoticationClose = () => {
        setOpenUpdateModal(false)
        setBulkStatusOpen(false)
    };
    //name autocomple req
    // useEffect(() => {
    //     setautocompleteDataName("");
    //     if (partnerId) {
    //         const getUserContactSuggestionReq = {
    //             actionCustomerMasterRequestVO: {
    //                 customerMobileOrName: "",
    //                 walletOwnerId: partnerId,
    //             },
    //         };
    //         dispatch(
    //             getUserNameContactSuggestionList(
    //                 getUserContactSuggestionReq,
    //                 authToken
    //             )
    //         );
    //         setboolSetName(true);
    //     }
    // }, [partnerId]);

    //Name autocomplete
    // const setDataAutocompleteNameFunc = () => {
    //     if (boolSetName) {
    //         if (getUsernameSuggestionRes.data.status === "Success") {
    //             setdataAutocompleteName(getUsernameSuggestionRes.data.list);
    //         }
    //         if (getUsernameSuggestionRes.data.status === "Failed") {
    //             if (
    //                 getUsernameSuggestionRes.data.description == "session out"
    //             ) {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 getUsernameSuggestionRes.data.description ==
    //                 "Authorization failed"
    //             ) {
    //                 regenerateToken(
    //                     dispatch,
    //                     authToken,
    //                     regenerateTokenRes.data.partnerId
    //                 );
    //             }
    //         }
    //         if (getUsernameSuggestionRes.data.status === "Not found") {
    //             setdataAutocompleteName([]);
    //         }
    //     }
    // };
    // useEffect(() => {
    //     setDataAutocompleteNameFunc();
    // }, [getUsernameSuggestionRes.data.status]);

    const inquiryHandleClick = (orderDesc) => {
        getInquiryReq(orderDesc)
        // getInquiryFunc()
    }
    const getInquiryReq = (orderDesc) => {
        const req = {
            actionCustomerMasterRequestVO: {
                orderDescription: orderDesc,

            }

        };
        return dispatch(
            getInquirysAdmin(
                req,
                regenerateTokenRes.data.AuthToken
            )
        );
    }

    useEffect(() => {
        return (() => {
            dispatch(resetGetWayTransactionList())
        })
    }, [])

    useEffect(() => {
        setInquiryOpenModal(false)

        return (() => {
            setInquiryOpenModal(false)
            dispatch(resetGetInquiryAdmin())

        })
    }, [])
    const getUpdateGateWayReq = () => {
        const request = {
            actionCustomerMasterRequestVO: {
                status: updateStatus,
                orderDescription: orgnDesc,
                remark: getRemark,
                initiatedBy: "admin",
                walletOwnerId: regenerateTokenRes.data.partnerId
            }

        }
        // console.log("REQUESTTTTTT", request)
        dispatch(AdminUpdateGatewayTransactions(request, authToken));
    }

    useEffect(() => {
        return () => {
            setViewUpdateResArray([])
        }
    }, [])


    useEffect(() => (setCheckBox(false)), [pageNo])



    const getUpdateGateWayFunc = () => {
        console.log("UPDATEGATEWAYssss", adminUpdateGatewayTransactionRes)
        if (adminUpdateGatewayTransactionRes.data.status === "success") {
            console.log("INSIDE CONSOLE SUCCESS")
            setViewUpdateResArray(
                adminUpdateGatewayTransactionRes.data
            );
            setNotificationRefundOpen(true)
            getgateWayTransactionListReq()
            // setInquiryOpenModal(true)


        }
        if (adminUpdateGatewayTransactionRes.data.status == "Failed") {
            setViewUpdateResArray(adminUpdateGatewayTransactionRes.data);
            setNotificationRefundOpen(true)
            if (
                adminUpdateGatewayTransactionRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, adminUpdateGatewayTransactionRes.data.partnerId);
            }
            if (
                adminUpdateGatewayTransactionRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (adminUpdateGatewayTransactionRes.data.status == "not found") {
            setViewUpdateResArray(adminUpdateGatewayTransactionRes.data);
            setNotificationRefundOpen(true)
            if (
                adminUpdateGatewayTransactionRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, adminUpdateGatewayTransactionRes.data.partnerId);
            }
            if (
                adminUpdateGatewayTransactionRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (adminUpdateGatewayTransactionRes.data.status == "failed") {
            setViewUpdateResArray(adminUpdateGatewayTransactionRes.data);
            setNotificationRefundOpen(true)
            if (
                adminUpdateGatewayTransactionRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, adminUpdateGatewayTransactionRes.data.partnerId);
            }
            if (
                adminUpdateGatewayTransactionRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }
    useEffect(() => {
        getUpdateGateWayFunc();
    }, [adminUpdateGatewayTransactionRes]);

    useEffect(() => {


        dispatch(resetUpdateGatewayTransactionAdmin())
    }, [])
    useEffect(() => {
        setNotificationRefundOpen(false)

        return (() => {
            setNotificationRefundOpen(false)
            dispatch(resetUpdateGatewayTransactionAdmin())

        })
    }, [])
    useEffect(() => {
        if (adminUpdateGatewayTransactionRes.data.status) {

            setNotificationRefundOpen(true)
        }
        getUpdateGateWayFunc();
        // console.log("inside eff", adminUpdateGatewayTransactionRes);
    }, [adminUpdateGatewayTransactionRes]);


    const handleClose = () => {
        setOpenUpdateModal(false)
        setInquiryOpenModal(false)
        setNotificationRefundOpen(false)



    }


    const updateHandleClick = (
        orgnDesc
    ) => {
        setorgnDesc(orgnDesc)
        setOpenUpdateModal(true)
    }

    const getInquiryFunc = () => {
        console.log("inquiryDetailsRessssss", adminInquiryDetailsRes)
        if (adminInquiryDetailsRes.data.status === "Success") {
            console.log("INSIDE CONSOLE SUCCESS")
            setViewInquiryDetailsResArray(
                adminInquiryDetailsRes.data.customerMasterDetailsRequestVO
            );
            setHandleOpenUpdateInqRespModal(true)

            // setInquiryOpenModal(true)


        }
        if (adminInquiryDetailsRes.data.status == "Failed") {
            setViewInquiryDetailsResArray(adminInquiryDetailsRes.data);
            if (
                adminInquiryDetailsRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, adminInquiryDetailsRes.data.partnerId);
            }
            if (
                adminInquiryDetailsRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (adminInquiryDetailsRes.data.status == "failed") {
            setViewInquiryDetailsResArray(adminInquiryDetailsRes.data);
            if (
                adminInquiryDetailsRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, adminInquiryDetailsRes.data.partnerId);
            }
            if (
                adminInquiryDetailsRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }

    useEffect(() => {
        if (adminInquiryDetailsRes.data.status) {

            setInquiryOpenModal(true)
        }
        getInquiryFunc();
        console.log("inside eff", adminInquiryDetailsRes);
    }, [adminInquiryDetailsRes]);

    const getWalletOwnerIdStatusFunc = () => {
        if (getWalletOwnerIdStatus) {
            if (getWalletOwnerIdRes.data.status == "success") {
                setGetWalletOwnerIdResArray(
                    [].concat(getWalletOwnerIdRes.data.ownerList)
                );
            }
            if (getWalletOwnerIdRes.data.status == "failed") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId || localStorage.getItem("walletOwnerId"));
                } 
            }
            if (getWalletOwnerIdRes.data.status == "NOT FOUND") {
                setGetWalletOwnerIdResArray(getWalletOwnerIdRes.data);
                if (
                    getWalletOwnerIdRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getWalletOwnerIdRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    const getWalletOwnerIdAndNameListReq = () => {
        setGetWalletOwnerIdStatus(true);
        dispatch(
            getWalletOwnerIdAndNameList(
                {
                    loginDetails: {
                        // adminId: "2"
                        adminId:val.adminIDS
                    }
                },
                authToken
            )
        );
    };
    useEffect(() => {
        // if (regenerateTokenRes.data.status == "success") {

        getWalletOwnerIdAndNameListReq();
        // }
    }, [regenerateTokenRes.data.AuthToken]);

    useEffect(() => {
        getWalletOwnerIdStatusFunc();
    }, [getWalletOwnerIdRes.data.status]);



    function countryFlagShow(countryNameLists) {
        console.log("CNNNAAAMMEEESLISTTT Before", countryNameLists)

        countryNameLists = countryNameLists.replace(/\w+/g,
            function (w) { return w[0].toUpperCase() + w.slice(1).toLowerCase(); });
        console.log("CNNNAAAMMEEESLISTTT After", countryNameLists)


        // console.log("COUNTRYYYYY", country)
        let countryS = require("../../assets/img/CountryFlags/" + getCodes(countryNameLists).toLowerCase() + ".png")
        // console.log("COUNTRYYYYY", country)

        return countryS;
    }

    const getTransactionTypeListRes = useSelector(
        ({ getTransactionTypeList }) => getTransactionTypeList
    );

    const getWayTransactionListRes = useSelector(
        ({ getWayTransactionList }) => getWayTransactionList
    );
    const getUsernameContactSuggestionRes = useSelector(
        ({ partnerGetUsernameContactSuggestionsLists }) => partnerGetUsernameContactSuggestionsLists
    )


    console.log(getWayTransactionListRes + "getWayTransactionListRes");
    console.log("getWayTransactionListResssss", getWayTransactionListRes);
    const [CustId, setCustId] = useState("");
    const [UserId, setUserId] = useState("");
    const [transId, setTransId] = useState('')
    // const [FromCustID, setFromCustID] = useState('')
    const onButtonClick = (transId, UserId) => {
        console.log("transIddddd", transId)
        console.log("UserId", UserId)
        if (open == transId) {
            setOpen(null)
        }
        else {
            setIsMaskedEmail(true)
            setOpen(transId)
        }
        setTransId(transId)
        setUserId(UserId)
        // setCustId(CustId)
        getGateWayTransactionFunc(transId, UserId)

        // console.log("btnnnn", FromCustID)

    };

    const getGateWayTransactionFunc = (transId, UserId) => {
        const getGateWayTransactionReq = {
            walletTransactionMasterDetailsRequestVO: {
                walletOwnerId: partnerIdForView.split("-")[0] || "",
                transactionId: transId,
                walletCustomerId: UserId
            }
        };

        return dispatch(
            getViewTransactionDetails(
                getGateWayTransactionReq,
                regenerateTokenRes.data.AuthToken
            )
        );
        // console.log("///getViewTrans", getGateWayTransactionReq)
        // console.log("emaillllss", viewTransactionDetailsResArray.custEmail)
    };

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            getGateWayTransactionFunc();
        }
    }, [customerId, regenerateTokenRes.data.status]);

    const viewTransactionDetailsResFunc = () => {
        if (viewTransactionDetailsRes.data.status == "success") {
            setViewTransactionDetailResArray(
                viewTransactionDetailsRes.data.transactionMasterDetailsResponseVO
            );
        }
        if (viewTransactionDetailsRes.data.status == "Failed") {
            setViewTransactionDetailResArray(viewTransactionDetailsRes.data);
            if (
                viewTransactionDetailsRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                viewTransactionDetailsRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    };


    useEffect(() => {
        viewTransactionDetailsResFunc();
    }, [viewTransactionDetailsRes.data.status]);

    const getTransactionTypeList = () => {
        if (getWayTransactionListStatus) {
            if (getWayTransactionListRes.data.status == "success") {
                setIsLoading(false);
                setGetTransactionTypeListResArray(
                    [].concat(getWayTransactionListRes.data.transactionList)
                );
            } else {
                setIsLoading(false);
                setGetTransactionTypeListResArray(getWayTransactionListRes.data);
                if (openPopup) {
                    NotificationPopups(
                        "error",
                        "Failed",
                        getWayTransactionListRes.data.description
                    );
                    setOpenPopUp(false)
                }

                // setgetWayTransactionListStatus(getWayTransactionListRes.data);
            }
        }
    };


    // const getWalletTransactionListFun = () => {
    //     if (getWayTransactionListStatus) {
    //         if (getWayTransactionListRes.data.status == "success") {
    //             setGetTransactionTypeListResArray(
    //                 [].concat(getWayTransactionListRes.data.transactionList)
    //             );
    //             setIsLoading(false);
    //             // setDownloadBtn(false);
    //         }
    //         if (getWayTransactionListRes.data.status == "failed") {
    //             setGetTransactionTypeListResArray(getWayTransactionListRes.data);
    //             setIsLoading(false);
    //             // setDownloadBtn(true);
    //             NotificationPopups(
    //                 "error",
    //                 "Failed",
    //                 getWayTransactionListRes.data.description ||
    //                 getWayTransactionListRes.description
    //             );
    //             if (getWayTransactionListRes.data.description == "session out") {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 getWayTransactionListRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(
    //                     dispatch,
    //                     authToken,
    //                     regenerateTokenRes.data.partnerId
    //                 );
    //             }
    //         }

    //         if (getWayTransactionListRes.data.status == "Failed") {
    //             setGetTransactionTypeListResArray(getWayTransactionListRes.data);
    //             setIsLoading(false);
    //             // setDownloadBtn(true);
    //             NotificationPopups(
    //                 "error",
    //                 "Failed",
    //                 getWayTransactionListRes.data.description ||
    //                 getWayTransactionListRes.description
    //             );
    //             if (getWayTransactionListRes.data.description == "session out") {
    //                 SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
    //             }
    //             if (
    //                 getWayTransactionListRes.data.description == "Authorization failed"
    //             ) {
    //                 regenerateToken(
    //                     dispatch,
    //                     authToken,
    //                     regenerateTokenRes.data.partnerId
    //                 );
    //             }
    //         }

    //         if (getWayTransactionListRes.data.status === "NOT FOUND") {
    //             setGetTransactionTypeListResArray(getWayTransactionListRes.data);
    //             setIsLoading(false);
    //             // setDownloadBtn(true);
    //             NotificationPopups(
    //                 "error",
    //                 "NOT FOUND",
    //                 getWayTransactionListRes.data.status
    //             );
    //         }
    //     }
    // };


    // useEffect(() => {
    //     if (getWayTransactionListRes.data.status == "success") {
    //         // setPage(0);
    //     }
    // }, [getWayTransactionListRes.data.status]);
    // useEffect(() => {
    //     console.log("getWalletTransactionListRes", getWayTransactionListRes);
    //     if (getWayTransactionListRes.data.status) { getWalletTransactionListFun(); }
    // }, [getWayTransactionListRes]);

    useEffect(() => {
        if (getWayTransactionListRes.data.status) {
            getTransactionTypeList();
        }
    }, [getWayTransactionListRes]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
    };

    const handleToDateChange = (date) => {
        setSelectedToDate(date);
    };

    const getCountryCodeFunc = (details, sel) => {
        if (!details) {
            return '';
        } else {
            let res = details.filter(ch => ch.mobile === sel)
            if (res.length == 0) {
                return '';
            } else {
                return res[0].countryCode;
            }
        }
    }

    const getgateWayTransactionListReq = () => {
        setPartnerIdForView(partnerId)
        setIsLoading(true);
        setgetWayTransactionListStatus(true);
        const getgateWayTransactionListReq = {
            walletTransactionMasterDetailsRequestVO: {
                walletOwnerId: partnerId == "Select Owner Id" ? "" : partnerId.split("-")[0],
                fromDate: moment(selectedDate).format("DD/MM/YYYY"),
                toDate: moment(selectedToDate).format("DD/MM/YYYY"),
                transactionId: transactionId,
                // transactionType: transactionType,
                transactionType: transactionType == "All" ? "" : transactionType,
                toCustomerContact: getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0])
                    ? getCountryCodeFunc(getUsernameContactSuggestionRes.data.list, customerOrMobName.split("-")[0])
                    + ' ' + customerOrMobName.split("-")[0] : customerOrMobName.split("-")[0],
                // toCustomerContact: customerOrMobName.split("-")[0],
                toCustomerName: toCustName,
                transactionStatus: transStatus === "All" ? "" : transStatus,
                // pageNo: transactionId ? 1 : pageNo + 1,
                pageNo: pageNoOne() ? 1 : pageNo + 1,
                records: rowsPerPage
            }
        };
        console.log('getgateWayTransactionListReq: ', getgateWayTransactionListReq)
        setOpenPopUp(true)
        return dispatch(
            getWayTransactionList(getgateWayTransactionListReq, authToken)
        );
    };

    const getGateWayTransactionResFunc = () => {
        if (getWayTransactionListStatus) {
            if (getWayTransactionListRes.data.status == "success") {
                setIsLoading(false);
                setGetTransactionTypeListResArray(
                    [].concat(getWayTransactionListRes.data.transactionList)
                );
            } 
        }
        if (getWayTransactionListRes.data.status == "Failed") {

            setGetTransactionTypeListResArray(getWayTransactionListRes.data);
            if (
                getWayTransactionListRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
            if (
                getWayTransactionListRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId ||  localStorage.getItem("walletOwnerId"));
            }
            else {
                setIsLoading(false);
                setGetTransactionTypeListResArray(getWayTransactionListRes.data);
                if (openPopup) {
                    NotificationPopups(
                        "error",
                        "Failed",
                        getWayTransactionListRes.data.description
                    );
                    setOpenPopUp(false)
                }

                // setgetWayTransactionListStatus(getWayTransactionListRes.data);
            }
        }
        
    };
    useEffect(()=>{
        getGateWayTransactionResFunc()
    },[getWayTransactionListRes])
    


    // IF ANY ONE ENTITY FOUND THEN PAGE NUMBER 1 GOING TO getgateWayTransactionListReq THIS REQUEST  
    function pageNoOne() {
        if (transactionType || transStatus || transactionId || toCustName || getCountryCodeFunc()) {
            return 1
        } else {
            return 0
        }
    }


    useEffect(() => {
        console.log("checking outside")
        if (getWayTransactionListRes.data.status == "success") {
            console.log("checking inside")
            getgateWayTransactionListReq();
        }

    }, [pageNo, rowsPerPage])


    useEffect(() => {
        console.log("checking outside")
        if (getWayTransactionListRes.data.status == "success") {
            console.log("checking inside")
            getgateWayTransactionListReq();
        }

    }, [pageNo, rowsPerPage])

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         getgateWayTransactionListReq();
    //     }
    // }, [regenerateTokenRes.data.status]);

    const handleChangePageForward = (pageaa, newPage) => {

        console.log("Arrow", newPage)
        setPageNo(newPage);
        // getgateWayTransactionListReq();

    };

    const handleChangeRowsPerPage = (event) => {

        setRowsPerPage(parseInt(event.target.value));
        setPageNo(0);

    };

    // const handleChangePage = (event, newPage) => {
    //     setPage(newPage);
    // };

    // const handleChangeRowsPerPage = (event) => {
    //     setRowsPerPage(parseInt(event.target.value, 10));
    //     setPage(0);
    // };


    // useEffect(() => {
    //     if (getUsernameContactSuggestionRes.data.status === "success") {
    //         console.log("lissttt", getUsernameContactSuggestionRes.data.list)
    //     }
    // }, [getUsernameContactSuggestionRes.data.status])

    // useEffect(() => {
    //     if (regenerateTokenRes.data.status == "success") {
    //         const getUserContactReq = {
    //             actionCustomerMasterRequestVO: {
    //                 customerMobileOrName: customerOrMobName,
    //                 walletOwnerId: regenerateTokenRes.data.partnerId || ""
    //             }
    //         }
    //         dispatch(getUserNameContactSuggestionList(getUserContactReq, authToken))
    //         // console.log("userContact", getUserContactReq)
    //     }
    // }, [regenerateTokenRes.data.status])
    const getUserNameReq = (walletOwnerIds) => {
        const req = {
            actionCustomerMasterRequestVO: {
                customerMobileOrName: toCustName,
                walletOwnerId: walletOwnerIds.split("-")[0]
            },
        };

        return dispatch(getUserNameContactSuggestionList(req, authToken))
    };
    const getUserContactReq = (walletOwnerIds) => {
        const req = {
            actionCustomerMasterRequestVO: {
                customerMobileOrName: customerOrMobName,
                walletOwnerId: walletOwnerIds.split("-")[0]
            },
        };

        return dispatch(getUserNameContactSuggestionList(req, authToken))
    };

    const filterOptions = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filteredOptions = options.filter(
            (option) =>
                option.mobile ? option.mobile.includes(inputValue) : '' ||
                    option.customerMobileOrName ? option.customerMobileOrName.includes(inputValue) : ''
        );

        return filteredOptions.slice(0, 20);
    }

    const filterOptionsName = (options, { inputValue }) => {
        if (inputValue.length < 3) {
            return [];
        }

        const filteredOptionsN = options.filter(
            (option) =>

                option.customerMobileOrName ? option.customerMobileOrName.includes(inputValue) : ''
        );

        return filteredOptionsN.slice(0, 20);
    }

    // BULK UPDATE
    const [checkBox, setCheckBox] = useState(false)
    const [selectAll, setSelectAll] = useState(false)
    const [checkValuesArr, setCheckValuesArr] = useState([])
    const [checkValueStatus, setCheckValueStatus] = useState([])

    const getBulkUpdateStatusReq = () => {
        const req = {
            actionCustomerMasterRequestVO: {
                mappingIdList: checkValuesArr,
                walletOwnerId: regenerateTokenRes.data.partnerId
            }
        }

        dispatch(partnerBulkUpdateStatus(req, authToken));

    }

    const getBulkUpdateStatusFunc = () => {
        if (BulkUpdateStatusPartnerRes.data.status === "success") {
            setCheckValueStatus(BulkUpdateStatusPartnerRes.data);
            setBulkStatusOpen(true)


        }
        if (BulkUpdateStatusPartnerRes.data.status === "Failed") {
            setCheckValueStatus(BulkUpdateStatusPartnerRes.data);

            setBulkStatusOpen(true)

            if (
                BulkUpdateStatusPartnerRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
            }
            if (
                BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (BulkUpdateStatusPartnerRes.data.status === "not found") {
            setCheckValueStatus(BulkUpdateStatusPartnerRes.data);

            setBulkStatusOpen(true)


            if (
                BulkUpdateStatusPartnerRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
            }
            if (
                BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
        if (BulkUpdateStatusPartnerRes.data.status == "failed") {
            setCheckValuesArr(BulkUpdateStatusPartnerRes.data);

            setBulkStatusOpen(true)

            if (
                BulkUpdateStatusPartnerRes.data.description == "session out"
            ) {
                SOLogout(dispatch, authToken, BulkUpdateStatusPartnerRes.data.partnerId);
            }
            if (
                BulkUpdateStatusPartnerRes.data.description == "Authorization failed"
            ) {
                regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
            }
        }
    }
    useEffect(() => {
        getBulkUpdateStatusFunc();

    }, [BulkUpdateStatusPartnerRes]);

    useEffect(() => {
        setCheckValuesArr([])

    }, [pageNo])
    const handleCheckbox = (event) => {
        console.log("EVEent", event.target.checked)
        const { name, checked } = event.target;
        setCheckBox(checked)
        console.log(checked, "ischeckedddd");
        if (checked) {
            console.log(getTransactionTypeListResArray, "geetttttingarr");
            let checkarr = getTransactionTypeListResArray &&
                []
                    .concat(getTransactionTypeListResArray).map((ele) => {
                        console.log("iminsideeeeemap");
                        return ele.transactionId
                    })
            console.log(checkarr, "checkarrrr");
            setCheckValuesArr([...checkarr])

        }
        else {
            setCheckValuesArr([])
        }
    };
    console.log("CHECKEDDD", checkBox)
    console.log("TICK", checkValuesArr)
    const handleSingleCheckbox = (e, transactionId) => {
        console.log("TRansactionID", transactionId)

        if (e.target.checked && !checkValuesArr.includes(transactionId)) {
            setCheckValuesArr([...checkValuesArr, transactionId])
        }
        else {
            let filterArr = checkValuesArr.filter((el) => {
                return el != transactionId
            })
            setCheckValuesArr([...filterArr])

        }

    }
    useEffect(() => {
        dispatch(resetBulkUpdateStatusPartner())
    }, [])
    useEffect(() => {
        setBulkStatusOpen(false);


        return () => {
            setBulkStatusOpen(false);

            dispatch(resetBulkUpdateStatusPartner())
        }
    }, [])


    return (
        <>
            <Layout>
                <Card>
                    {/* <BackButton /> */}
                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="From Date"
                                        format="MM/dd/yyyy"
                                        value={selectedDate}
                                        onChange={handleDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <FormControl fullWidth>
                                <LocalizationProvider dateAdapter={AdapterDateFns}>
                                    <DatePicker
                                        label="To Date"
                                        format="MM/dd/yyyy"
                                        value={selectedToDate}
                                        onChange={handleToDateChange}
                                        disableFuture={true}
                                    />
                                </LocalizationProvider>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                variant="standard"
                                label="Transaction Id"
                                type="tel"
                                fullWidth
                                value={transactionId}
                                name="transactionId"
                                onChange={handleChange}
                                style={{ marginTop: "3px" }}
                                InputProps={{
                                    sx: {
                                      "&:before": { borderBottomColor: "gray" }, // before focus
                                      "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                  }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={3}>
                            <TextField
                                required
                                margin="dense"
                                variant="standard"

                                select
                                style={{ marginTop: "3px" }}

                                color="primary"
                                type="text"
                                label="Owner ID"
                                fullWidth
                                name="partnerId"
                                // value={walletOwnerId}
                                defaultValue={"Select Owner Id" || partnerId}
                                onChange={handleChange}
                                sx={{
                                    "& .MuiInput-underline:before": {
                                      borderBottomColor: "gray", // White color for the underline before focus
                                    },
                                    "& .MuiInput-underline:hover:not(.Mui-disabled):before": {
                                      borderBottomColor: "gray", // White color on hover
                                    },
                                    "& .MuiInput-underline:after": {
                                      borderBottomColor: "gray", // White color after focus
                                    },
                                  }}

                            >
                                <MenuItem value="Select Owner Id" selected="Select Owner Id">
                                    Select Owner Id
                                </MenuItem>
                                {console.log("GETARRAYowner", getWalletOwnerIdResArray)}
                                {getWalletOwnerIdResArray.status !== "failed" && getWalletOwnerIdRes.data.ownerList &&
                                    getWalletOwnerIdResArray.map((x) => (
                                        <MenuItem value={x.split("-")[0]}>{x}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                autoFocus
                                variant="standard"

                                margin="dense"
                                id="name"
                                label="Transaction Type"
                                type="tel"
                                fullWidth
                                style={{ marginTop: "3px" }}
                                // value={transactionType}
                                name="transactionType"
                                onChange={handleChange}
                                defaultValue={"All" || transactionType}
                                InputProps={{
                                    sx: {
                                      "&:before": { borderBottomColor: "gray" }, // before focus
                                      "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                  }}
                            >
                                <MenuItem value="All" selected="All">
                                    All
                                </MenuItem>
                                <MenuItem value="LOAD">LOAD</MenuItem>
                                {/* <MenuItem value="VOUCHER PURCHASE">VOUCHER PURCHASE</MenuItem> */}
                            </TextField>
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                autoFocus
                                margin="dense"
                                id="name"
                                label="Customer Name"
                                type="tel"
                                fullWidth
                                value={toCustName}
                                name="toCustName"
                                onChange={handleChange}
                                style={{ marginTop: "3px" }}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    // getUsernameContactSuggestionRes.data.list && getUsernameContactSuggestionRes.data.list || [""]
                                    getUsernameSuggestionRes.data.list || [""]
                                )}
                                // getOptionLabel={(option) => option.customerMobileOrName}
                                getOptionLabel={(option) => option.customerMobileOrName}

                                filterOptions={filterOptionsName}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        style={{ marginTop: "3px" }}
                                        variant="standard"

                                        margin="dense"
                                        id="name"
                                        label="Name"
                                        // required
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={toCustName || ""}
                                        name="toCustName"
                                        onBlur={handleChange}
                                        sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
                                    />
                                )}

                            />
                        </Grid>
                        {/* <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={dataAutocompleteName || []}
                                getOptionLabel={(option) =>
                                    option
                                        ?

                                        option.customerMobileOrName
                                        : ``
                                }
                                filterOptions={filterOptionsName}
                                value={autocompleteDataName}
                                onChange={(event, value) => setautocompleteDataName(value)}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        margin="dense"
                                        label="Name"
                                        style={{ marginTop: "3px" }}
                                        type="text"
                                        fullWidth
                                        {...params}
                                        name="toCustName"
                                    />
                                )}
                            />
                        </Grid> */}
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <TextField
                                select
                                autoFocus
                                margin="dense"
                                variant="standard"

                                id="name"
                                label="Transaction Status"
                                type="tel"
                                fullWidth
                                style={{ marginTop: "3px" }}
                                // value={transactionType}
                                name="transStatus"
                                onChange={handleChange}
                                defaultValue={"All" || transStatus}
                                InputProps={{
                                    sx: {
                                      "&:before": { borderBottomColor: "gray" }, // before focus
                                      "&:after": { borderBottomColor: "gray" },  // after focus
                                    },
                                  }}
                                  InputLabelProps={{
                                    sx: { color: 'gray' }, // Optional: if you want the label to be white
                                  }}
                            >
                                <MenuItem value="All" selected="All">
                                    All
                                </MenuItem>
                                <MenuItem value="Success">Success</MenuItem>
                                <MenuItem value="Failed">Failed</MenuItem>
                                <MenuItem value="Pending">Pending</MenuItem>
                                <MenuItem value="Cancelled">Cancelled</MenuItem>
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={12} md={3} lg={3}>
                            <Autocomplete
                                id="combo-box-demo"
                                options={[].concat(
                                    // getUsernameContactSuggestionRes.data.list && getUsernameContactSuggestionRes.data.list || [""]
                                    getUsernameContactSuggestionRes.data.list || [""]
                                )}
                                getOptionLabel={(option) => option.mobile + "-" + option.customerMobileOrName}
                                filterOptions={filterOptions}
                                renderInput={(params) => (
                                    <TextField
                                        autoFocus
                                        style={{ marginTop: "3px" }}
                                        variant="standard"

                                        margin="dense"
                                        id="name"
                                        label="Customer Mob No"
                                        // required
                                        type="text"
                                        fullWidth
                                        {...params}
                                        value={customerOrMobName || ""}
                                        name="customerOrMobName"
                                        onBlur={handleChange}
                                        sx={{
											"& .MuiInput-underline:before": {
											  borderBottomColor: "gray", // White color for the underline before focus
											},
											"& .MuiInput-underline:hover:not(.Mui-disabled):before": {
											  borderBottomColor: "gray", // White color on hover
											},
											"& .MuiInput-underline:after": {
											  borderBottomColor: "gray", // White color after focus
											},
										  }}
                                    />
                                )}

                            />
                        </Grid>

                    </Grid>

                    <Grid
                        container
                        style={{
                            padding: "10px",
                            marginTop: "1.5rem",
                            marginBottom: "15px"
                        }}
                    >
                        <Grid item md={5}>
                            {/* <Button
                style={{
                  marginLeft: "0.7rem",
                  backgroundColor: "#00b9f5",
                  color: "white",
                }}
                endIcon={<AiOutlineSearch />}
                variant="contained"
                onClick={getgateWayTransactionListReq}
              >
                Search
              </Button> */}
                            <CustomButton
                                style={{
                                    padding: "8px",
                                    marginLeft: "15px"
                                }}
                                onClick={getgateWayTransactionListReq}
                            >
                                Search <SearchIcon />
                            </CustomButton>
                        </Grid>
                        <Grid item md={7}></Grid>
                    </Grid>
                </Card>

                {isLoading ? (
                    <LoadingSpinner />
                ) : getTransactionTypeListResArray.length == undefined ||
                    !getWayTransactionListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Transaction List
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 tableHeaderColor"
                                    variant="secondary"
                                // style={{ backgroundColor: "#00b9f5", color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Transaction List
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="my-3">
                                <Table className={classes.table}>
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >

                                                <input type="checkbox"
                                                    name="allValues"
                                                    checked={checkBox}
                                                    onChange={(e) => { handleCheckbox(e); }}
                                                ></input>

                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}

                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Transaction Id{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Order Description
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                From Customer Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Transaction Status
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Transaction Type
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Transaction Amount
                                            </TableCell>
                                            {/* <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Transaction Currency
                                            </TableCell> */}
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Transaction Date
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {getTransactionTypeListResArray &&
                                            []
                                                .concat(getTransactionTypeListResArray)
                                                // .slice(
                                                //     page * rowsPerPage,
                                                //     page * rowsPerPage + rowsPerPage
                                                // )
                                                .map((row, index) => (
                                                    <>
                                                        <TableRow key={index}>
                                                            {/* <TableCell>
                                <CustomButton
                                  style={{
                                    marginTop: "1rem",
                                    marginLeft: "1rem",
                                  }}
                                  onClick={() =>
                                    gateWayTransactionDetails(
                                      row.transactionId,
                                      row.toCustomerId
                                    )
                                  }
                                >
                                  {row.transactionId}
                                </CustomButton>

                              </TableCell> */}
                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                <input type="checkbox"
                                                                    name="checkbox"
                                                                    checked={[].concat(checkValuesArr).includes(row.transactionId)}
                                                                    onChange={(e) => handleSingleCheckbox(e, row.transactionId)}
                                                                ></input>
                                                            </TableCell>

                                                            <TableCell style={{ borderBottom: "0" }}>
                                                                <IconButton
                                                                    aria-label="expand row"
                                                                    size="small"
                                                                    onClick={() => onButtonClick(row.transactionId, row.toCustomerId)}
                                                                >
                                                                    {open == row.transactionId ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell
                                                                align="center"
                                                                className=""
                                                                style={{ borderBottom: "0" }}
                                                            // style={{
                                                            // 	marginTop: "1rem",
                                                            // 	// marginLeft: "rem",
                                                            // 	// color: "#00b9f5",
                                                            // 	cursor: "pointer",
                                                            // 	fontWeight: "600"
                                                            // }}
                                                            // onClick={() =>
                                                            // 	gateWayTransactionDetails(
                                                            // 		row.transactionId,
                                                            // 		row.toCustomerId
                                                            // 	)
                                                            // }
                                                            >
                                                                {row.transactionId}
                                                            </TableCell>

                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {row.orderDescription}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {row.fromCustomerName}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {row.transactionStatus}
                                                            </TableCell>
                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {row.transactionType}</TableCell>

                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {" "}
                                                                {getSymbolFromCurrency(row.currency) +
                                                                    " " + row.transactionAmount}
                                                                {/* {row.transactionAmount} */}
                                                            </TableCell>
                                                            {/* <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {" "}
                                                                {row.currency}
                                                            </TableCell> */}
                                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                                {" "}
                                                                {row.fromDate}
                                                            </TableCell>
                                                            <TableCell align="center">
                                                                <Grid xs={12} sm={12} md={12} lg={12} style={{ display: "flex" }}>
                                                                    {row.transactionType === "REFUND" ?
                                                                        <Tooltip title="Inquiry">
                                                                            <CustomButton
                                                                                disabled={true}



                                                                                // disabled={row.transactionStatus !== "Pending"}
                                                                                style={{
                                                                                    padding: "8px"
                                                                                }}


                                                                                onClick={() =>
                                                                                    inquiryHandleClick(row.orderDescription)
                                                                                }


                                                                            >

                                                                                <FindInPageIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            </CustomButton>
                                                                     </Tooltip> 
                                                                        :

                                                                        <Tooltip title="Inquiry">
                                                                            <CustomButton
                                                                                disabled={(row.transactionStatus == "Pending") || (row.transactionStatus == "Success") ? false : true}

                                                                                // disabled={row.transactionStatus !== "Pending"}
                                                                                style={{
                                                                                    padding: "8px"
                                                                                }}

                                                                                // disabled={row.transactionStatus !== "Pending"}


                                                                                onClick={() =>
                                                                                    inquiryHandleClick(row.orderDescription)
                                                                                }


                                                                            >

                                                                                <FindInPageIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            </CustomButton>
                                                                        </Tooltip>
                                                                        }
                                                                    {/* <Tooltip title="Update"> */}
<Tooltip title="Update">
                                                                        <CustomButton
                                                                            // disabled={(row.transactionStatus == "Pending" || row.transactionStatus == "Success") ? false : true}
                                                                            disabled={row.transactionStatus !== "Pending" || row.transactionType === "REFUND"}
                                                                            style={{
                                                                                padding: "8px",
                                                                                marginLeft: "10px"
                                                                            }}


                                                                            onClick={() =>
                                                                                updateHandleClick(row.orderDescription)
                                                                            }


                                                                        >

                                                                            <EditIcon
                                                                                style={{
                                                                                    color: "#fff",
                                                                                    fontSize: "20px"
                                                                                }}
                                                                            />
                                                                        </CustomButton>
                                                                        </Tooltip>
                                                                    {/* </Tooltip> */}
                                                                </Grid>


                                                            </TableCell>
                                                        </TableRow>
                                                        <TableRow>
                                                            <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                                                                <Collapse
                                                                    in={open == row.transactionId || row.customerId}

                                                                    timeout="auto"
                                                                    // onClick={() => onButtonClick(row.fromCustomerId
                                                                    // )}
                                                                    unmountOnExit
                                                                >
                                                                    <Box margin={4}>
                                                                        {/* <TableContainer
																		component={Paper}
																		style={{
																			marginBottom: "30px"
																		}}
																	> */}
                                                                        {viewTransactionDetailsRes.data
                                                                            .transactionMasterDetailsResponseVO &&
                                                                            viewTransactionDetailsRes.data
                                                                                .transactionMasterDetailsResponseVO ? (
                                                                            <>
                                                                                {viewTransactionDetailsResArray && (
                                                                                    <Table
                                                                                        className={classes.table}
                                                                                        aria-label="a dense table"
                                                                                        style={{ whiteSpace: "nowrap" }}
                                                                                    >
                                                                                        {/* <TableHead>
																							<TableRow className="themeBackground">
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Tracking Id{" "}
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Payment Id
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Purchase Amount
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Currency
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Status
																								</TableCell>
																								<TableCell
																									align="center"
																									style={{ fontWeight: "bold", color: "white" }}
																								>
																									Date
																								</TableCell>
																							</TableRow>
																						</TableHead> */}

                                                                                        <TableBody>
                                                                                            {viewTransactionDetailsResArray &&
                                                                                                []
                                                                                                    .concat(viewTransactionDetailsResArray)
                                                                                                    .map((row, index) => (
                                                                                                        <TableRow key={index}>
                                                                                                            <Row>
                                                                                                                <Col md={12}>
                                                                                                                    <Typography
                                                                                                                        variant="h6"
                                                                                                                        component="div"
                                                                                                                        className="mt-1"
                                                                                                                        style={{
                                                                                                                            fontSize: "1.4rem",
                                                                                                                            // paddingTop: "1%",
                                                                                                                            // paddingBottom: "1.5%",

                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Customer Details
                                                                                                                    </Typography>
                                                                                                                    <hr />
                                                                                                                    <Row >
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Customer Id	</Col>
                                                                                                                                <Col md={6}>

                                                                                                                                    {!row.toCustomerId || row.toCustomerId == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.toCustomerId}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Customer Name</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.fromCustomerName || row.fromCustomerName == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.fromCustomerName}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    <hr />
                                                                                                                    <Row>
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Country Code</Col>
                                                                                                                                <Col md={6}> {!row.manualCode || row.manualCode == "" ? "-" : row.manualCode}</Col>

                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Customer Email</Col>
                                                                                                                                {/* <Col md={6}>
																																	{" "}
																																	{!row.custEmail || row.custEmail == ""
																																		? "-"
																																		: row.custEmail}
																																</Col> */}
                                                                                                                                <Col md={5}>



                                                                                                                                    {/* {isMaskedEmail ? row.custEmail.substring(0, row.custEmail.lastIndexOf("@")) + "xxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail} */}
                                                                                                                                    {/* {isMaskedEmail ? row.custEmail.substring(0, 1) + "xxxx." + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail} */}
                                                                                                                                    {row.custEmail && isMaskedEmail ? row.custEmail.substring(0, 1) + "xxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@"), row.custEmail.length) : row.custEmail}







                                                                                                                                    {/* {
																																		isMaskedEmail ? row.custEmail.split("@")[0] + "xxxxx" + row.custEmail.substring(row.custEmail.lastIndexOf("@") + 1) : row.custEmail
																																	} */}

                                                                                                                                </Col>

                                                                                                                                <Col md={1}><span style={{ cursor: "pointer" }} onClick={() => setIsMaskedEmail(!isMaskedEmail)}> {isMaskedEmail ? <VisibilityOff className="EyeIcons" /> : <Visibility className="EyeIcons" />}
                                                                                                                                </span> </Col>

                                                                                                                            </Row>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    <hr />
                                                                                                                    <Row >
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>From contact</Col>
                                                                                                                                <Col md={6}>

                                                                                                                                    {!row.fromContact || row.fromContact == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.fromContact}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Beneficiery Contact</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.toCustomerContact || row.toCustomerContact == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.toCustomerContact}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>
                                                                                                                    </Row>


                                                                                                                </Col>
                                                                                                            </Row>

                                                                                                            <Row>
                                                                                                                <Col md={12}>
                                                                                                                    <Typography
                                                                                                                        variant="h6"
                                                                                                                        component="div"
                                                                                                                        className="mt-3"
                                                                                                                        style={{
                                                                                                                            fontSize: "1.4rem",
                                                                                                                            // paddingTop: "3.5%",
                                                                                                                            // paddingBottom: "1.5%",
                                                                                                                        }}
                                                                                                                    >
                                                                                                                        Transaction Details
                                                                                                                    </Typography>
                                                                                                                    <hr />
                                                                                                                    <Row>
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Transaction Id</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.transactionId || row.transactionId == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.transactionId}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Payment Id</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.paymentId || row.paymentId == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.paymentId}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    <hr />
                                                                                                                    <Row>
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Purchase Amount</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.transactionAmount || row.transactionAmount == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.transactionAmount}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Currency</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.currency || row.currency == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.currency}
                                                                                                                                </Col>
                                                                                                                            </Row>


                                                                                                                        </Col>
                                                                                                                    </Row>
                                                                                                                    <hr />
                                                                                                                    <Row>
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Status</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.transactionStatus || row.transactionStatus == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.transactionStatus}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>
                                                                                                                        <Col md={6} class="detail-info row">
                                                                                                                            <Row>

                                                                                                                                <Col md={6}>Transaction SubType</Col>
                                                                                                                                <Col md={6}>
                                                                                                                                    {!row.transactionSubType || row.transactionSubType == ""
                                                                                                                                        ? "-"
                                                                                                                                        : row.transactionSubType}
                                                                                                                                </Col>
                                                                                                                            </Row>
                                                                                                                        </Col>



                                                                                                                        {/* <Col md={6} class="detail-info row">
																															<Row>

																																<Col md={6}>Date</Col>
																																<Col md={6}>
																																	{!row.timestamp || row.timestamp == ""
																																		? "-"
																																		: row.timestamp}
																																</Col>
																															</Row>


																														</Col> */}
                                                                                                                    </Row>
                                                                                                                    <hr />

                                                                                                                </Col>

                                                                                                            </Row>
                                                                                                            {(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') && (row.cardHolderName === '-' || row.cardHolderName === '')
                                                                                                                && (row.binCountry === '-' || row.binCountry === '')
                                                                                                                ? '' :
                                                                                                                <Row>
                                                                                                                    <Col md={12}>
                                                                                                                        <Typography
                                                                                                                            variant="h6"
                                                                                                                            component="div"
                                                                                                                            className="mt-3"
                                                                                                                            style={{
                                                                                                                                fontSize: "1.4rem",
                                                                                                                            }}
                                                                                                                        >
                                                                                                                            Account Details
                                                                                                                        </Typography>
                                                                                                                        <hr />
                                                                                                                        <Row >
                                                                                                                            <Col md={6} class="detail-info row">
                                                                                                                                <Row>

                                                                                                                                    <Col md={6}>Account Holder</Col>
                                                                                                                                    <Col md={6}>
                                                                                                                                        {!row.cardHolderName || row.cardHolderName == ""
                                                                                                                                            ? "-"
                                                                                                                                            : row.cardHolderName}

                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                            <Col md={6} class="detail-info row">
                                                                                                                                <Row>

                                                                                                                                    <Col md={6}>Account Number</Col>
                                                                                                                                    <Col md={6}>
                                                                                                                                        {/* {!row.firstSix + "xxxx" + !row.lastFour ||
																											row.firstSix + "xxxx" + row.lastFour === "" ? "-"
																											: row.firstSix + "xxxx" + row.lastFour} */}
                                                                                                                                        {!row.firstSix + !row.lastFour ||
                                                                                                                                            row.firstSix + row.lastFour === "" ? "-"
                                                                                                                                            : row.firstSix + "XXXXXX" + row.lastFour}

                                                                                                                                    </Col>
                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                            {/* <Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Bin Country</Col>
																																	<Col md={6}>

																																		{!row.binCountry || row.binCountry == ""
																																			? "-"
																																			: row.binCountry}

																																	</Col>
																																</Row>
																															</Col> */}
                                                                                                                        </Row>
                                                                                                                        <hr />
                                                                                                                        <Row>
                                                                                                                            <Col md={6} class="detail-info row">
                                                                                                                                <Row>

                                                                                                                                    <Col md={6}>Bin Country</Col>
                                                                                                                                    {/* {console.log("PassBinCountry", row.binCountry)} */}
                                                                                                                                    {/* <Col md ={6}>
																																		{row.binCountry === "-" ? "" :}
																																	</Col> */}
                                                                                                                                    <Col md={6}>
                                                                                                                                        {console.log("PassBinCountry", row.binCountry)}
                                                                                                                                        {row.binCountry === "-" ? "" : row.binCountry ?


                                                                                                                                            (
                                                                                                                                                <div>
                                                                                                                                                    <img src={countryFlagShow(row.binCountry)} style={{ height: "20px", width: "20px", marginRight: "10px" }} />
                                                                                                                                                    <span>{row.binCountry}</span>
                                                                                                                                                </div>
                                                                                                                                            )
                                                                                                                                            : ""}
                                                                                                                                    </Col>

                                                                                                                                    {/* <Col md={6}>

																																		{!row.binCountry || row.binCountry == ""
																																			? "-"
																																			: row.binCountry}

																																	</Col> */}

                                                                                                                                </Row>
                                                                                                                            </Col>
                                                                                                                        </Row>
                                                                                                                        {/* <Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>First Six</Col>
																																	<Col md={6}>
																																		{!row.firstSix || row.firstSix == ""
																																			? "-"
																																			: row.firstSix}
																																	</Col>
																																</Row>
																															</Col>
																															<Col md={6} class="detail-info row">
																																<Row>
																																	<Col md={6}>Last Four</Col>
																																	<Col md={6}>
																																		{!row.lastFour || row.lastFour == ""
																																			? "-"
																																			: row.lastFour}
																																	</Col>
																																</Row>
																															</Col>
																														</Row> */}
                                                                                                                        <hr />

                                                                                                                    </Col>
                                                                                                                </Row>
                                                                                                            }

                                                                                                            {/* {(row.firstSix === '-' || row.firstSix === '') && (row.lastFour === '-' || row.lastFour === '') && (row.cardHolderName === '-' || row.cardHolderName === '') ? '' :
																												<Row>
																													<Col md={12}>
																														<Typography
																															variant="h6"
																															component="div"
																															className="mt-3"
																															style={{
																																fontSize: "1.4rem",
																																// paddingTop: "3.5%",
																																// paddingBottom: "1.5%",
																															}}
																														>
																															Account Details
																														</Typography>
																														<hr />
																														<Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>First Six</Col>
																																	<Col md={6}>
																																		{!row.firstSix || row.firstSix == ""
																																			? "-"
																																			: row.firstSix}
																																	</Col>
																																</Row>
																															</Col>

																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Last Four</Col>
																																	<Col md={6}>
																																		{!row.lastFour || row.lastFour == ""
																																			? "-"
																																			: row.lastFour}
																																	</Col>
																																</Row>
																															</Col>
																														</Row>
																														<hr />
																														<Row >
																															<Col md={6} class="detail-info row">
																																<Row>

																																	<Col md={6}>Card Holder Name</Col>
																																	<Col md={6}>
																																		{!row.cardHolderName || row.cardHolderName == ""
																																			? "-"
																																			: row.cardHolderName}
																																	</Col>
																																</Row>
																															</Col>
																					
																														</Row>
																														<hr />
																															</Col>
																												</Row>} */}
                                                                                                            <Typography
                                                                                                                variant="h6"
                                                                                                                component="div"
                                                                                                                className="mt-3"
                                                                                                                style={{
                                                                                                                    fontSize: "1.4rem",
                                                                                                                    // paddingTop: "3.5%",
                                                                                                                    // paddingBottom: "1.5%",
                                                                                                                }}
                                                                                                            >
                                                                                                                Transaction History
                                                                                                            </Typography>
                                                                                                            <hr />

                                                                                                            <div className="ViewTranHistory">
                                                                                                                <TableContainer component={Paper} >
                                                                                                                    <Table
                                                                                                                        className={classes.table}
                                                                                                                        aria-label="a dense table"
                                                                                                                        style={{ whiteSpace: "nowrap" }}
                                                                                                                    >
                                                                                                                        <TableHead>
                                                                                                                            <TableRow className="">
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Action{" "}
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Timestamp
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Transaction Type
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Purchase Amount
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Currency
                                                                                                                                </TableCell>
                                                                                                                                <TableCell
                                                                                                                                    align="center"
                                                                                                                                    style={{ color: "black" }}
                                                                                                                                >
                                                                                                                                    Remark
                                                                                                                                </TableCell>
                                                                                                                            </TableRow>
                                                                                                                        </TableHead>
                                                                                                                        <TableBody>
                                                                                                                            {viewTransactionDetailsResArray.transactionHistoryVOList &&
                                                                                                                                []
                                                                                                                                    .concat(viewTransactionDetailsResArray.transactionHistoryVOList)
                                                                                                                                    .map((row, index) => (
                                                                                                                                        <TableRow key={index}>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.status ? row.status : "-"}
                                                                                                                                            </TableCell>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.timestamp ? row.timestamp : "-"}
                                                                                                                                            </TableCell>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.transactionType ? row.transactionType : "-"}
                                                                                                                                            </TableCell>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.amount ? row.amount : "-"}
                                                                                                                                            </TableCell>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.currency ? row.currency : "-"}
                                                                                                                                            </TableCell>
                                                                                                                                            <TableCell align="center">
                                                                                                                                                {row.remark ? row.remark : "-"}
                                                                                                                                            </TableCell>

                                                                                                                                        </TableRow>
                                                                                                                                    ))
                                                                                                                            }
                                                                                                                        </TableBody>
                                                                                                                    </Table>
                                                                                                                </TableContainer>
                                                                                                            </div>



                                                                                                            {/* <TableCell align="center">
																												{row.transactionId
																													? row.transactionId
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.paymentId ? row.paymentId : "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.transactionAmount
																													? row.transactionAmount
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.currency ? row.currency : "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.transactionStatus
																													? row.transactionStatus
																													: "-"}
																											</TableCell>
																											<TableCell align="center">
																												{row.timestamp ? row.timestamp : "-"}
																											</TableCell> */}
                                                                                                        </TableRow>
                                                                                                    ))}
                                                                                        </TableBody>
                                                                                    </Table>
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            ""
                                                                        )}
                                                                        {/* </TableContainer> */}
                                                                    </Box>
                                                                </Collapse>

                                                            </TableCell>
                                                        </TableRow>
                                                    </>
                                                ))}
                                    </TableBody>
                                </Table>
                                {/* <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getTransactionTypeListResArray.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                /> */}
                                <Grid item xs={12} sm={12} md={6} lg={6}>
                                    <CustomButton
                                        style={{
                                            padding: "8px",
                                            marginLeft: "100%"
                                        }}
                                        onClick={getBulkUpdateStatusReq}
                                    >
                                        Update
                                    </CustomButton>
                                </Grid>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={getWayTransactionListRes.data.count}
                                    rowsPerPage={rowsPerPage}
                                    page={pageNo}
                                    // ActionsComponent={TablePaginationActions}
                                    onPageChange={handleChangePageForward}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                    // handleChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Grid>
                    </Card>
                )}
            </Layout>
            <div>
                {inquiryOpenModal && (
                    <Dialog open={inquiryOpenModal} onClose={handleClose} maxWidth="md" fullWidth>
                        <DialogTitle>Inquiry Details</DialogTitle>
                        <DialogTitle>Gateway Name : {" "}
                            {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.integrationName ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.integrationName : "-"}
                        </DialogTitle>
                        <DialogContent dividers>
                            <TableContainer component={Paper} style={{ overflow: 'hidden' }}>
                                <Table>
                                    <TableHead>
                                        <TableRow className="tableHeaderColor">
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Payment Id
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Status
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Currency
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Remark
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Amount
                                            </TableCell>
                                            <TableCell align="center" style={{ fontWeight: "bold", color: "white" }}>
                                                Order Description
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.paymentId : "-"}
                                            </TableCell>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.status ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.status : "-"}
                                            </TableCell>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.currency ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.currency : "-"}
                                            </TableCell>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.remark ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.remark : "-"}
                                            </TableCell>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.amount ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.amount : "-"}
                                            </TableCell>
                                            <TableCell align="center" style={{ borderBottom: "0" }}>
                                                {adminInquiryDetailsRes.data.customerMasterDetailsRequestVO && adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.orderDescription ? adminInquiryDetailsRes.data.customerMasterDetailsRequestVO.orderDescription : "-"}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </DialogContent>
                        <DialogActions className="p-3">
                            <CustomButton style={{ color: "white" }} variant="contained" onClick={handleClose}>
                                Close
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                )}
            </div>



            <div>
                <Dialog open={openUpdateModal} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Update Inquiry Details</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            // autoFocus={true}
                            type="text"
                            label="Order Description"
                            fullWidth={true}
                            name="orgnDesc"
                            variant="standard"
                            value={orgnDesc || ""}
                            onChange={handleChange}
                            disabled
                        />

                        <TextField
                            autoFocus
                            margin="dense"
                            label="Remark"
                            name="getRemark"
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                            value={getRemark || ""}
                        />
                        <TextField
                            select
                            autoFocus
                            margin="dense"
                            label="Status"
                            name="updateStatus"
                            type="text"
                            fullWidth
                            variant="standard"
                            onChange={handleChange}
                        // defaultValue={isBankDefault || "Select Status"}
                        >
                            <MenuItem value="Success">Success</MenuItem>
                            <MenuItem value="Failed">Failed</MenuItem>
                            <MenuItem value="Pending">Pending</MenuItem>

                        </TextField>
                    </DialogContent>
                    <DialogActions>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={() => getUpdateGateWayReq()}
                        >
                            Update
                        </CustomButton>

                    </DialogActions>
                </Dialog>
            </div>



            <div>
                {viewUpdateResArray.status == "success" && <Dialog open={notificationRefundOpen} onClose={handleClose}>
                    <DialogContent
                        className="text-center lightThemeBackground"
                    // style={{ backgroundColor: "#00b9f51c" }}
                    >
                        <img src={success} alt="" width="100px" className="my-2" />
                    </DialogContent>
                    <DialogTitle style={{ width: "400px", textAlign: "center" }}>
                        {viewUpdateResArray.description}

                    </DialogTitle>
                    <DialogActions>
                        <CustomButton
                            style={{
                                padding: "8px"
                            }}
                            onClick={handleClose}
                        >
                            Close
                        </CustomButton>
                    </DialogActions>

                </Dialog>}
            </div>

            {(checkValueStatus.status === "success" || checkValueStatus.status === "Success") && (
                <div>
                    <Dialog
                        open={bulkStatusOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {checkValueStatus.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {(checkValueStatus.status === "failed" || checkValueStatus.status === "FAILED") && (
                <div>
                    <Dialog
                        open={bulkStatusOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {checkValueStatus.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {checkValueStatus.status === "not found" && (
                <div>
                    <Dialog
                        open={bulkStatusOpen}
                        onClose={handleNoticationClose}
                    >
                        <DialogContent
                            className="text-center"
                            style={{ backgroundColor: "#00b9f51c" }}
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {checkValueStatus.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <Button
                                style={{
                                    margin: "10px 0",
                                    backgroundColor: "#00b9f5",
                                    color: "white"
                                }}
                                variant="contained"
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </Button>
                        </DialogActions>
                    </Dialog>
                </div>
            )}
        </>
    )
}

export default AdminTransaction